import { BROADCAST_NOTIFICATION_TYPE } from "@/entities/broadcast-notification";
import { useEventBusListener } from "@/modules/event-bus";

import { useJobModuleActionCompleted } from "./job-module-action-completed.hook";

const JobModuleActionCompleted = () => {
  const { runAction } = useJobModuleActionCompleted();

  useEventBusListener(
    BROADCAST_NOTIFICATION_TYPE.JOB_MODULE_COMPLETED,
    runAction
  );

  return <></>;
};

export default JobModuleActionCompleted;
